import 'waypoints/lib/noframework.waypoints.min'
import 'element-closest'
import 'vanilla-ripplejs'
// import 'modal-vanilla'
import './frontend.scss'
import common from './routes/common'
import page from './routes/page'
import singlePost from './routes/blog'
import home from './routes/home'
import sustainableDevelopment from './routes/sd'
import awards from './routes/awards'
import overview from './routes/overview'
import ceoBoard from './routes/board'
import autoPartsProduction from './routes/parts'

// import product from './routes/product'
// import checkout from './routes/checkout'
import jobs from './routes/job'

import contact from './routes/contact'
import Router from './util/Router'

const singleCsr = singlePost

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  common,
  home,
  page,
  singlePost,
  singleCsr,
  sustainableDevelopment,
  contact,
  jobs,
  awards,
  overview,
  ceoBoard,
  autoPartsProduction,
})

window.addEventListener('DOMContentLoaded', () => {
  routes.loadEvents()
})
